export class UtilConfigAnalytics {

  static ConfigAnalytics(
    local: string | null,
    texto: string | null = null,
    id: string | null = null,
    ambiente: string | null = 'deslogado',
    rotuloPagina: string | null = '',
    pageTitle: string | null = '',
    itemText: string | null = '',
    area: string | null = '',
    acao: string | null = '',
    content_type: string | null = ''
  ): ConfigAnalytics {
    let resultado: any;

    switch (local) {
      case 'page_view':
        resultado = {
          event: "page_view",
          page_location: window.location.href,
          page_title: pageTitle,
          page_path: window.location.pathname,
          vertical_produto: "serasa-institucional",
          area: area,
          ambiente: ambiente
        }
        break;


      case 'page_view_ga4':
        resultado = {
          event: "page_view_ga4",
          page_location: window.location.href,
          page_title: pageTitle,
          page_path: window.location.pathname,
          vertical_produto: "serasa-institucional",
          area: area,
          ambiente: ambiente
        }
        break;

      // case 'select-content-ga4':
      //   resultado = {
      //     event: "select_content_ga4",
      //     item_id: id,
      //     content_type: 'botao',
      //     item_text: 'acesse-seus-dados',
      //     vertical_produto: "serasa-institucional",
      //     area: "lgpd-conheca-seus-direitos",
      //     ambiente: "logado"
      //   }
      //   break;

      // case 'select-content':
      //   resultado = {
      //     event: "select_content",
      //     categoria: 'serasa-institucional-lgpd',
      //     acao: 'clique-botao',
      //     rotulo: 'acesse-seus-dados',
      //     vertical_produto: "serasa-institucional",
      //     area: "lgpd-conheca-seus-direitos",
      //     ambiente: "deslogado"
      //   }
        break;

      case 'pagina-relatorio-sintetico':
        resultado = {
          event: "page_view_ga4",
          page_location: window.location.origin,
          page_title: "Serasa Institucional - LGPD - Relatorio Sintetico",
          page_path: "/protecaodados-pessoais/relatoriosintetico",
          vertical_produto: "serasainstitucional",
          area: "lgpd-relatorio-sintetico",
          ambiente: "deslogado"
        }
        break;

      case 'entrar-tela':
        resultado = {
          event: 'entrar_tela',
          categoria: 'serasa-institucional-lgpd',
          acao: 'entrar-tela',
          rotulo: rotuloPagina,
          vertical_produto: 'serasa-institucional',
          area: area,
          ambiente: ambiente
        }
        break;

      case 'entrar-tela-ga4':
        resultado = {
          event: 'entrar_tela_ga4',
          item_text: itemText,
          vertical_produto: 'serasa-institucional',
          area: area,
          ambiente: 'deslogado'
        }
        break;

      case 'select_content_ga4':
        resultado = {
          event: 'select_content_ga4',
          item_id: id,
          content_type: content_type,
          item_text: itemText,
          vertical_produto: 'serasa-institucional',
          area: area,
          ambiente: ambiente
        }
        break;

      case 'select_content':
        resultado = {
          event: 'select_content',
          categoria: 'serasa-institucional-lgpd',
          acao: acao,
          rotulo: rotuloPagina,
          vertical_produto: 'serasa-institucional',
          area: area,
          ambiente: ambiente
        }
        break;

    }
    return resultado
  }

  static ConfigAnalyticsCard(
    local: string | null,
    item_id: string | null = '',
    content_type: string | null = '',
    item_text: string | null = '',
    vertical_produto: string | null = '',
    area: string | null = '',
    ambiente: string | null = '',
    categoria: string | null = '',
    acao: string | null = '',
    rotulo: string | null = ''
  ): ConfigAnalytics {

    let resultado: any;

    switch (local) {

      case 'select-content-ga4':
        resultado = {
          event: "select_content_ga4",
          item_id: item_id,
          content_type: content_type,
          item_text: item_text,
          vertical_produto: vertical_produto,
          area: area,
          ambiente: ambiente
        }
        break;

      case 'select-content':
        console.log('chegando ');

        resultado = {
          event: "select_content",
          categoria: categoria,
          acao: acao,
          rotulo: rotulo,
          vertical_produto: vertical_produto,
          area: area,
          ambiente: ambiente
        }
        break;



    }
    return resultado
  }
}

export interface ConfigAnalytics {
  event: string | null
  page_location?: string | null
  page_title?: string | null
  page_path?: string | null
  vertical_produto: string | null
  area: string | null
  ambiente: string | null
  item_id?: string | null
  content_type?: string | null
  item_text?: string | null
  acao?: string | null
  rotulo?: string | null
  categoria?: string | null,

}
